var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-wrap"}},[_c('div',{staticClass:"container"},[_c('Application'),_c('Message'),_c('CloudDisk')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }